export const env = process.env.VUE_APP_WEB

export const config =  {
  local: {
    wechatFinderService: 'https://test-gateway.jinyi999.cn/invest-adviser-service/api/1/skynet',
    launcherService: 'https://test-gateway.jinyi999.cn',
    yintechService: 'https://test-gateway.jinyi999.cn',
    launcherService1: 'https://test-gateway.jinyi999.cn',
    behaviorUrl: 'https://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/add',
    socketUrl: 'https://test-online.jinyi999.cn?param=',
    wechat: {
      scope: 'snsapi_userinfo',
      state: '',
      defaultAvatar: require('../assets/wechat/default-avatar.png')
    },
    environConfig: {
      uri: 'https://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/spark/json/add',
      secret: `jX894Ui8YQom81Ss`,
      iv: `9985661470321659`
    },
    appDownloadUrl: 'https://test-jsapp.jinyi999.cn/rjhy/activity-h5/x-jfql-weichat.html',
    rjhySocketUrl: 'https://test-gateway.techgp.cn/rjhy-minilive-center'
  },
  development: {
    wechatFinderService: 'https://test-gateway.jinyi999.cn/invest-adviser-service/api/1/skynet',
    launcherService: 'https://test-gateway.jinyi999.cn',
    yintechService: 'https://test-gateway.jinyi999.cn',
    behaviorUrl: 'https://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/add',
    socketUrl: 'https://test-online.jinyi999.cn?param=',
    wechat: {
      scope: 'snsapi_userinfo',
      state: '',
      defaultAvatar: require('../assets/wechat/default-avatar.png')
    },
    environConfig: {
      uri: 'https://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/spark/json/add',
      secret: `jX894Ui8YQom81Ss`,
      iv: `9985661470321659`
    },
    appDownloadUrl: 'https://test-jsapp.jinyi999.cn/rjhy/activity-h5/x-jfql-weichat.html',
    rjhySocketUrl: 'https://test-gateway.techgp.cn/rjhy-minilive-center'
  },
  uat: {
    wechatFinderService: 'https://uat-gw.chongnengjihua.com/invest-adviser-service/api/1/skynet',
    launcherService: 'https://uat-gw.chongnengjihua.com',
    yintechService: 'https://test-gateway.jinyi999.cn',
    behaviorUrl: 'https://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/add',
    socketUrl: 'https://test-online.jinyi999.cn?param=',
    wechat: {
      scope: 'snsapi_userinfo',
      state: '',
      defaultAvatar: require('../assets/wechat/default-avatar.png')
    },
    environConfig: {
      uri: 'https://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/spark/json/add',
      secret: `jX894Ui8YQom81Ss`,
      iv: `9985661470321659`
    },
    appDownloadUrl: 'https://uat-wechat.chongnengjihua.com/rjhy/activity-h5/x-jfql-weichat.html',
    rjhySocketUrl: 'https://uat-gw.chongnengjihua.com/rjhy-minilive-center'
  },
  production: {
    launcherService1: 'https://gateway.jinyi999.cn',
    launcherService: 'https://gateway.jinyi999.cn',
    yintechService: 'https://gateway.chongnengjihua.com',
    wechatFinderService: 'https://gateway.jinyi999.cn/invest-adviser-service/api/1/skynet',
    behaviorUrl: 'https://gateway.jinyi999.cn/rjhy-user-behavior/api/1/behavior/add',
    socketUrl: 'https://online.jinyi999.cn?param=',
    wechat: {
      scope: 'snsapi_userinfo',
      state: '',
      defaultAvatar: require('../assets/wechat/default-avatar.png')
    },
    environConfig: {
      uri: 'https://gateway.jinyi999.cn/rjhy-user-behavior/api/1/behavior/spark/json/add',
      secret: `jX894Ui8YQom81Ss`,
      iv: `9985661470321659`
    },
    appDownloadUrl: 'https://wechat.chongnengjihua.com/rjhy/activity-h5/x-jfql-weichat.html',
    rjhySocketUrl: 'https://gateway.chongnengjihua.com/rjhy-minilive-center',
  }
}[env]
